import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useRoutes,
} from "react-router-dom";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import "./index.css";
import AuditJournal from "./components/helix-audit/JournalItemTable";
import AuditCaseStatus from "./components/helix-audit/CaseStatus";
import AuditCaseJournal from "./components/helix-audit/CaseJournal";
import AuditClient from "./components/helix-audit/Client";
import ProductAudit from "./components/helix-audit/ProductAudit";
import PracticeAudit from "./components/helix-audit/PracticeAudit";
import RLSCostCenterCodes from "./components/RLS/RLSCostCenterCodes";
import ReportSecurity from "./components/RLS/ReportSecurity";
import CallFlowLayout from "./components/call-flow/CallFlow";
import CallFlowLayoutHolidays from "./components/call-flow/CallFlowHolidays";
import ViewNumbers from "./components/call-flow/ViewNumbers"
import PaymentImport from "./components/finance/PaymentImport";
import CreditControlTaskImport from "./components/finance/CreditControlTaskImport";
import LocumReport from "./components/freshcrm";
import LocumAuditAccess from "./components/freshcrm/LocumReportAccessAudit";
import PrivateHome from "./components/home/Private";
import PublicHome from "./components/home/Public";
import Sidebar from "./components/nav/Sidebar";
import NavBar from "./components/nav/NavBar";
import Footer from "./components/nav/Footer";
import Burger from "./components/nav/Burger";
import EnhancedSearch from "./components/helix-audit/EnhancedSearch";
import { useSessionStorage } from "./hooks/useSessionStorage";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import PartnerPracticePortalAudit from "./components/helix-audit/PartnerPracticePortal";
import Send from "./components/MessageHub/Send";
import BulkId from "./components/MessageHub/BulkId";
import Conversation from "./components/MessageHub/Conversation";
import Notifications from "./components/MessageHub/Notifications";
import MerakiDashboard from "./components/call-flow/MerakiDashboard";
import { clarity } from "react-microsoft-clarity";


var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_AZURE_APPINSIGHTS_CONN,
    extensions: [reactPlugin],
  },
});

function App() {
  const [theme, setTheme] = useState({
    palette: {
      type: "light",
    },
  });
  const [isAuthenticated, userHasAuthenticated] = useSessionStorage(
    "userHasAuthenticated",
    false
  );
  const [user, setUser] = useSessionStorage("user", null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  clarity.init("r92otf6cmh");

  useEffect(() => {
    if (!user) getUserInfo();
    // appInsights.loadAppInsights();
  }, []);

  const logoutUser = () => {
    setUser(null);
    userHasAuthenticated(false);
  };

  const toggleSideBar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const muiTheme = createTheme(theme);

  async function getUserInfo() {
    try {
      const response = await fetch("/.auth/me");
      const payload = await response.json();
      const { clientPrincipal } = payload;

      if (clientPrincipal) {
        setUser(clientPrincipal);
        userHasAuthenticated(true);
      }
    } catch (error) {
      console.error("No profile could be found " + error?.message?.toString());
    }
  }

  const routes = [
    { path: "/", element: <PrivateHome toggleSideBar={toggleSideBar} /> },
    { path: "/JournalAudit/:id?", element: <AuditJournal /> },
    {
      path: "/CaseStatusAudit/:id?",
      element: <AuditCaseStatus />,
    },
    {
      path: "/CaseJournalAudit/:id?",
      element: <AuditCaseJournal  />,
    },
    { path: "/CasePractice/:id?", element: <PracticeAudit/> },
    { path: "/Client/:id?", element: <AuditClient /> },
    { path: "/ProductAudit/:id?", element: <ProductAudit /> },
    { path: "/CallFlow/", element: <CallFlowLayout /> },
    { path: "/CallFlowHolidays/", element: <CallFlowLayoutHolidays /> },
    { path: "/PaymentImport/", element: <PaymentImport /> },
    { path: "/CreditControlTaskImport/", element: <CreditControlTaskImport /> },
    { path: "/LocumReport/", element: <LocumReport /> },
    { path: "/LocumReportAccessAudit/", element: <LocumAuditAccess /> },
    { path: "/ReportSecurity/", element: <ReportSecurity user={user} /> },
    { path: "/ReportSecurity/:report?", element: <RLSCostCenterCodes user={user} />},
    { path: "/EnhancedSearch/", element: <EnhancedSearch /> },
    { path: "/PartnerPracticeAudit/", element: <PartnerPracticePortalAudit /> },
    { path: "/MessageHub/Send/", element: <Send /> },
    { path: "/MessageHub/Bulk/:cosmosId?", element:  <BulkId /> },
    { path: "/MessageHub/Conversation/:conversationId?", element: <Conversation  /> },
    { path: "/MessageHub/Notifications/", element: <Notifications /> },
    { path: "/meraki-dashboard/", element: <MerakiDashboard /> },
  ];

  const routeResult = useRoutes(routes);

  return (
    <div className="App">
      <Burger open={sidebarOpen} setOpen={toggleSideBar} />
      <MuiThemeProvider theme={muiTheme}>
        <NavBar
          user={user}
          logoutUser={logoutUser}
          toggleSideBar={toggleSideBar}
        />
        <main className="column">
          {isAuthenticated ? routeResult : <PublicHome />}
        </main>
        <Sidebar open={sidebarOpen} toggleSideBar={toggleSideBar} user={user} />
        <Footer />
      </MuiThemeProvider>
    </div>
  );
}

export default App;
